/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Output } from '@angular/core';
import { ISettingsAmiDetail } from './ami-details.interface';

@Component({
  template: ''
})
export class AmiDetailsTemplate {
  @Output() onSelect = new EventEmitter<any>();
  settings: ISettingsAmiDetail;

  select = {
    canBeDisplay: false,
    id: undefined
  };

  setDataInSettings(data: any) {
    this.settings.body.rows = this.settings.body.rows.map((row) => {
      row.value = data[row.field];
      return row;
    });
  }

  addActionSelect() {
    const actionSelect = {
      name: 'select',
      icon: 'pi pi-check-square',
      class: 'p-button-rounded p-button-info',
      pTooltip: 'Seleccionar'
    };
    if (this.settings.head.actions) {
      this.settings.head.actions.push(actionSelect);
    } else {
      this.settings.head.actions = [actionSelect];
    }
  }

  // clear(row) {
  //   if (row) {
  //     this.setDataInSettings(row);
  //     this.onSelect.emit(row);
  //     this.select.id = row.id;
  //   }
  // }
  // clear2(row) {
  //   this.addActionSelect();
  // }
  onReciveAction(action) {
    if (action.name === 'select') {
      this.select.canBeDisplay = true;
    }
  }

  onSelected(row) {
    this.select.canBeDisplay = false;
    if (row) {
      this.setDataInSettings(row);
      this.onSelect.emit(row);
      this.select.id = row.id;
    }
  }
}
